import { useMemo } from "react";
import { MessagePartInputExtended } from "@/pages/BulkMessaging/types";
import { getMessagePartContent } from "@/pages/BulkMessaging/utils/apiHelpers";

const filterEmptyMessageParts = (messageParts: MessagePartInputExtended[]) => {
  return messageParts.filter((messagePart) => {
    const content = getMessagePartContent(messagePart);

    if (content.text !== undefined) {
      return (
        content.text && content.text.trim() !== "" && !content.isImageElement
      );
    }

    if (content.attachment) {
      return true;
    }

    return false;
  });
};

export const useFilteredMessageParts = (
  messageParts: MessagePartInputExtended[],
) => {
  const filteredMessageParts = useMemo(() => {
    return filterEmptyMessageParts(messageParts);
  }, [messageParts]);

  return { filteredMessageParts };
};
